import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/utils/api";

export const fetchOldConventional = createAsyncThunk(
  "cfc/fetchOldConventional",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`/modernization/${id}`);
      return response?.data?.data || {};
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch modernization"
      );
    }
  }
);

export const fetchOldConventionalAvailable = createAsyncThunk(
  "cfc/fetchOldConventionalAvailable",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/modernization_available_limit`);
      return response?.data?.data || {};
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch modernization"
      );
    }
  }
);

const initialState = {
  data: {},
  current_tab: "personal",
  available_limit: {},
  data_loading: false,
  user_initiated_nav: false,
  error: null,
};

const oldConventionalSlice = createSlice({
  name: "oldConventional",
  initialState,
  reducers: {
    setData: (state, action) => {
      state.data = {
        ...(state.data || {}),
        ...(action.payload || {}),
      };
    },
    clearError: (state) => {
      state.error = null;
    },
    setCurrentTab: (state, action) => {
      state.current_tab = action.payload;
    },
    setDataLoading: (state, action) => {
      state.data_loading = action.payload;
    },
    setUserInitiatedNav: (state, action) => {
      state.user_initiated_nav = action.payload;
    },
    resetOldConventionalSliceState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOldConventional.pending, (state) => {
        state.data_loading = true;
        state.error = null;
      })
      .addCase(fetchOldConventional.fulfilled, (state, action) => {
        state.data_loading = false;
        state.data = action.payload || {};
      })
      .addCase(fetchOldConventional.rejected, (state, action) => {
        state.data_loading = false;
        state.error = action.payload;
      })
      .addCase(fetchOldConventionalAvailable.pending, (state) => {
        state.data_loading = true;
        state.error = null;
      })
      .addCase(fetchOldConventionalAvailable.fulfilled, (state, action) => {
        state.data_loading = false;
        state.available_limit = action.payload || {};
      })
      .addCase(fetchOldConventionalAvailable.rejected, (state, action) => {
        state.data_loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setData,
  setCurrentTab,
  setDataLoading,
  clearError,
  resetOldConventionalSliceState,
  setUserInitiatedNav,
} = oldConventionalSlice.actions;
export default oldConventionalSlice.reducer;
